import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversionAttributionContainer = lazy(() =>
  import("@scenes/ConversionAttribution/scenes/ConversionAttributionContainer").then((module) => ({
    default: module.ConversionAttributionContainer,
  }))
);

export const conversionsNRO: NavigationRoutingObject = {
  Component: ConversionAttributionContainer,
  componentFeatureFlippers: ["conversions_nro_component"],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("conversion-attribution-dashboard-sidebar-pill-menu-option", "Conversions"),
  pageNameForTracking: () => "Conversions",
  featureLimitationKeys: ["can_only_view_landing_page_conversion_dashboard"],
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    const userHasPermission = featureOn("reporting_permissions_update") ? userHasViewReportingPermission : true;
    return isImpersonating || userHasPermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("conversion-attribution-alt-keyword-1", "Upon Receipt"),
        t("conversion-attribution-alt-keyword-2", "Upon Open"),
        t("conversion-attribution-alt-keyword-3", "Upon Click"),
        t("conversion-attribution-alt-keyword-4", "Upon Last-Touch"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
